import { useTranslation } from "react-i18next";

export default function HeroCompact() {
  const { t } = useTranslation("diensten");

  return (
    <section className="bg-brand-cream min-h-[50vh] flex items-center">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-16 md:py-24 w-full">
        <div className="max-w-4xl">
          <span className="inline-block font-geist font-bold text-xs tracking-widest uppercase bg-brand-yellow text-brand-text px-4 py-1.5 rounded-full mb-6">
            {t("hero.pill")}
          </span>
          <h1 className="font-geist font-bold text-4xl md:text-5xl lg:text-[64px] leading-[1.1] text-brand-text tracking-tight mb-6">
            {t("hero.h1")}
          </h1>
          <p className="font-geist text-lg md:text-xl text-brand-text/70 leading-relaxed max-w-2xl mb-10">
            {t("hero.subhead")}
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a
              href="#offerte"
              className="font-geist font-bold text-sm bg-brand-blue text-white px-7 py-3.5 rounded-full hover:bg-brand-text transition-colors whitespace-nowrap"
            >
              {t("hero.ctaPrimary")}
            </a>
            <a
              href="tel:+31407987470"
              className="font-geist font-bold text-sm border-2 border-brand-text text-brand-text px-7 py-3 rounded-full hover:bg-brand-text hover:text-white transition-colors whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              {t("hero.ctaPhone")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}